import { Outlet } from 'react-router-dom';

// components
import MainNavbar from './MainNavbar';
import MainFooter from './MainFooter';
import DashboardLayout from 'layouts/dashboard';

// ----------------------------------------------------------------------

export default function AdminLayout() {
  return (
    <>
      {/* <MainNavbar />  */}
      {DashboardLayout}

      <div>
        <Outlet />
      </div>

      {/* <MainFooter /> */}
    </>
  );
}
